export default __webpack_public_path__ + "static/area_4-b53140014e6992be799426ee2797161c.jpg";